export default __webpack_public_path__ + "static/media/iconiq-group@2x.8634c66b.png";